import React from "react";
import { Helmet } from "react-helmet-async";
import "./CookiePolicy.css";

const CookiePolicy = () => {
  return (
    <div className="cookie-policy-page">
      <Helmet>
        <title>Çerez Politikası | ProgenX Gizlilik ve Veri Koruma 2025</title>
        <meta name="description" content="ProgenX Çerez Politikası. Web sitemizde kullanılan çerezler, kişisel verilerin korunması, KVKK uyumluluğu ve çerez yönetimi hakkında detaylı bilgiler. Çerezleri nasıl yönetebileceğinizi öğrenin." />
        <meta name="keywords" content="progenx çerez politikası, çerez kullanımı, gizlilik politikası, kvkk, kişisel verilerin korunması, çerez yönetimi, veri güvenliği" />
        <meta property="og:title" content="Çerez Politikası | ProgenX" />
        <meta property="og:description" content="ProgenX web sitesi çerez kullanımı ve gizlilik politikası." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://progenxacademy.com/cerez-politikasi" />
        <link rel="canonical" href="https://progenxacademy.com/cerez-politikasi" />
      </Helmet>
      <div className="container">
        <div className="cookie-policy-header">
          <h1>Çerez Politikası</h1>
          <p className="subtitle">ProgenX Eğitim ve Bilişim Teknolojileri A.Ş.</p>
        </div>

        <div className="cookie-policy-content">
          <div className="intro-section">
            <h2>Web Sitesi Gizlilik ve Çerez Politikası</h2>
            <p>
              ProgenX Eğitim ve Bilişim Teknolojileri A.Ş. ("ProgenX") olarak gizliliğinize saygı duyulmaktayız ve veri güvenliğinize önem vermekteyiz. Bu kapsamda, ProgenX tarafından işletilen web sitesini ziyaret edenlerin ("ziyaretçi") kişisel verilerini 6698 sayılı Kişisel Verilerin Korunması Kanunu ("Kanun" ya da "KVKK") uyarınca işlemekte ve gizliliğini korumaktayız.
            </p>
            <p>
              Bu Çerez Politikası ile sizlere, çerezlerin kullanımı sırasında elde edilen kişisel verilerin hangi amaçlarla işlendiğini, hangi tür çerezleri kullandığımızı ve bu çerezleri nasıl yönetebileceğinizi açıklamak istiyoruz. Kullandığımız zorunlu çerezler haricindeki çerezler için çerez yönetim aracı ile ziyaretçilerin açık rızaları alınmakta ve ziyaretçilere rızalarını istedikleri zaman değiştirebilme olanağı sağlanmaktadır.
            </p>
          </div>

          <div className="table-of-contents">
            <h3>İçindekiler</h3>
            <ol>
              <li>ProgenX kimdir?</li>
              <li>Çerez (Cookie) Nedir ve Neden Kullanılmaktadır?</li>
              <li>Web Sitesinde Çerezler Hangi Amaçlar İçin Kullanılabilir?</li>
              <li>Hangi Tür Çerezleri Hangi Şekillerde Kullanıyoruz?</li>
              <li>Çerezlerle Kişisel Verilerinizi, Hangi Amaçlar ve Hukuki Sebeplere Dayanarak İşliyoruz?</li>
              <li>Çerez Yönetimi</li>
              <li>Kişisel Verileriniz Kimlere, Hangi Amaçla ve Hukuki Sebeple Aktarılmaktadır?</li>
              <li>Çerezlerin Kullanılmasını Nasıl Engelleyebilirsiniz?</li>
              <li>Kişisel verilerinizle ilgili olarak haklarınız nelerdir?</li>
              <li>Politikanın Yürürlüğü</li>
              <li>İletişim</li>
            </ol>
          </div>

          <div className="policy-section">
            <h2>1. ProgenX kimdir?</h2>
            <p>
              ProgenX Eğitim ve Bilişim Teknolojileri Anonim Şirketi, Üniversiteler Mah. İhsan Doğramacı Bul. No: 31 İç Kapı No: 20 Çankaya/Ankara ODTÜ Teknokent ETKİM Binası adresinde faaliyet gösteren 7331258939 Vergi Kimlik Numaralı ProgenX Eğitim ve Bilişim Teknolojileri A.Ş. kısaca ProgenX'dir. İletişim için detaylı bilgi bu Web Sitesi Gizlilik ve Çerez Politikası'nın 11. maddesi altında yer almaktadır.
            </p>
          </div>

          <div className="policy-section">
            <h2>2. Çerez (Cookie) Nedir ve Neden Kullanılmaktadır?</h2>
            <p>
              Çerez (Cookie), herhangi bir internet sitesi tarafından bilgisayara bırakılan bir tür tanımlama dosyasıdır. Çerez dosyalarında oturum bilgileri ve benzeri veriler saklanır. Çerez kullanan bir site ziyaret edildiğinde bu site, erişimin yapıldığı tarayıcıya sabit diske bir ya da daha fazla çerez bırakma konusunda talep gönderebilir. Çerezler, siteyi ziyaret eden kişilere ait isim, yaş, adres, cinsiyet gibi kişisel verileri barındırmazlar. Çerezler hakkında daha detaylı bilgi edinmek için lütfen www.aboutcookies.org ve www.allaboutcookies.org sitelerini ziyaret ediniz.
            </p>
          </div>

          <div className="policy-section">
            <h2>3. Web Sitesinde Çerezler Hangi Amaçlar İçin Kullanılabilir?</h2>
            <ul>
              <li>Web sitesinin çalışması için gerekli olan işlevleri yerine getirilmesi</li>
              <li>Ziyaret ve deneyim kişiselleştirme, hedefleme, doğru ve amaca dönük reklam ve tanıtım faaliyetleri</li>
              <li>Web sitesi ve bileşenlerinin işlevlerinin doğru, kolay ve daha verimli çalışması</li>
              <li>Web sitesini, kaynak kullanımı, erişen bilgisi, ziyaretçi sayısı ve platformlarının tespiti gibi bilgileri analiz ederek performansın arttırılması ve kullanıcı deneyiminin iyileştirilmesi</li>
              <li>Şirketin, 5651 sayılı İnternet Ortamında Yapılan Yayınların Düzenlenmesi ve Bu Yayınlar Yoluyla İşlenen Suçlarla Mücadele Edilmesi Hakkında Kanun'dan kaynaklananlar başta olmak üzere, kanuni ve sözleşmesel yükümlülüklerini yerine getirebilmesi için IP adresiniz gibi kişisel verilerinize ihtiyaç duyması</li>
            </ul>
          </div>

          <div className="policy-section">
            <h2>4. Hangi Tür Çerezleri Hangi Şekillerde Kullanıyoruz?</h2>
            <p>
              Web Sitesi'nde farklı türlerde çerezler kullanmaktayız. Bunlar Web Sitesi'nin çalışmasını sağlamak için kullanılması zorunlu olan çerezler, işlev çerezleri, analiz/performans çerezleri ve hedefleme/reklam çerezleridir.
            </p>
            
            <h3>4.1. Kullanım Bakımından Çerez Türleri:</h3>
            <div className="cookie-types">
              <h4>4.1.1. Kullanılması Zorunlu Olan Çerezler:</h4>
              <p>Bu çerezler, Web Sitesi'nin düzgün şekilde çalışması için mutlaka gerekli olan çerezlerdir. Bu çerezlere, sistemin yönetilebilmesi, sahte işlemlerin önlenmesi için ihtiyaç vardır ve engellenmesi halinde Web Sitesi gerektiği gibi çalışamayacaktır.</p>
              
              <h4>4.1.2. İşlev Çerezleri:</h4>
              <p>Bu çerezler size daha gelişmiş ve kolay bir kullanım deneyimi yaşatmak için kullanılan çerezlerdir. Örneğin önceki tercihlerinizi hatırlamak, Web Sitesi üzerinde yer alan bazı içeriklere rahatça erişmenizi sağlamak işlevlerini yerine getirmektedir.</p>
              
              <h4>4.1.3. Analiz/Performans Çerezleri:</h4>
              <p>Bu çerezler, Web Sitesi'nin işleyişini analiz edip anlamamızı sağlayan ve sizinle etkileşime geçerek Web Sitesi'ni geliştirebilmemizi sağlamaktadır.</p>
              
              <h4>4.1.4. Hedefleme/Reklam Çerezleri:</h4>
              <p>Bu çerezler, size, reklam içerikleri de dâhil olmak üzere, ilginizi çekebilecek içerikleri saptayarak sunmamız için kullanılmaktadır.</p>
            </div>

            <h3>4.2. Saklandığı Süre Bakımından Çerez Türleri:</h3>
            <div className="cookie-duration">
              <h4>4.2.1. Kalıcı Çerezler (Persistent Cookies):</h4>
              <p>Kişinin bilgisayarında belirli bir tarihe veya kullanıcı tarafından silinene kadar varlığını sürdüren çerezlerdir.</p>
              
              <h4>4.2.2. Oturum Çerezleri (Session Cookies):</h4>
              <p>Bu çerezler kullanıcının ziyaretini oturumlara ayırmak için kullanılır ve kullanıcıdan veri toplamaz.</p>
            </div>

            <h3>4.3. Sahipliklerine göre Çerez türleri:</h3>
            <div className="cookie-ownership">
              <h4>4.3.1. Birinci Taraf Çerezleri:</h4>
              <p>Doğrudan ziyaretçinin ziyaret ettiği internet sayfası tarafından yerleştirilmektedir.</p>
              
              <h4>4.3.2. Üçüncü Taraf Çerezleri:</h4>
              <p>Web Site ziyaretçisinin ziyaret ettiği internet sitesinden farklı bir üçüncü kişi tarafından yerleştirilmektedir.</p>
            </div>
          </div>

          <div className="policy-section">
            <h2>5. Çerezlerle Kişisel Verilerinizi, Hangi Amaçlar ve Hukuki Sebeplere Dayanarak İşliyoruz?</h2>
            <p>
              Çerezler, türlerine bağlı olmak üzere, genel olarak, Web Sitesi'ne eriştiğiniz cihazda tarama ve kullanım tercihlerinize ilişkin verileri toplamaktadır. Bu veriler, eriştiğiniz sayfaları, incelediğiniz hizmet ve ürünlerimizi, Web Sitesi'nde yaptığınız gezintiye ilişkin tüm bilgileri kapsamaktadır.
            </p>
          </div>

          <div className="policy-section">
            <h2>6. Çerez Yönetimi</h2>
            <p>
              Zorunlu çerezler haricindeki çerezleri önlemek için çerez yönetim panelindeki butonları tercihinize göre açık veya kapalı konuma getirerek "Değişiklikleri Kaydet" butonuna tıklayınız. Ayarları etkin hale getirmek için sayfayı yenileyiniz.
            </p>
          </div>

          <div className="policy-section">
            <h2>7. Çerezlerin Kullanılmasını Nasıl Engelleyebilirsiniz?</h2>
            <p>
              Çerezlerin kullanılması Web Sitesi'nin daha iyi hizmet vermekle birlikte eğer dilerseniz çerezlerin kullanılmasını engelleyebilirsiniz. Çerezlerin kullanılmasını engellemek için kullandığınız internet tarayıcınızın ayarlarınızı değiştirmeniz gerekmektedir.
            </p>
            
            <div className="browser-instructions">
              <h3>Tarayıcı Ayarları:</h3>
              <h4>Google Chrome:</h4>
              <ol>
                <li>Bilgisayarınızda Chrome'u açın</li>
                <li>Sağ üstte Diğer → Ayarlar'ı tıklayın</li>
                <li>Altta Gelişmiş'i tıklayın</li>
                <li>"Gizlilik ve güvenlik"in altında İçerik ayarları'nı tıklayın</li>
                <li>Çerezler'i tıklayın</li>
              </ol>

              <h4>Mozilla Firefox:</h4>
              <ol>
                <li>Firefox Menü düğmesine tıklayın ve Seçenekler'i seçin</li>
                <li>Gizlilik ve Güvenlik panelini seçin</li>
                <li>Geçmiş bölümüne gidin</li>
                <li>Çerezleri yönetin</li>
              </ol>

              <h4>Safari:</h4>
              <ol>
                <li>Safari → Tercihler'i seçin</li>
                <li>Gizlilik öğesini tıklayın</li>
                <li>Web Sitesi Verilerini yönetin</li>
              </ol>
            </div>
          </div>

          <div className="policy-section">
            <h2>8. Kişisel verilerinizle ilgili olarak haklarınız nelerdir?</h2>
            <p>
              Kişisel Verilerin Korunması Kanunu'nun 11. maddesi gereğince sahip olduğunuz hakları aşağıda sizin için sıraladık:
            </p>
            <ul>
              <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
              <li>Kişisel verileriniz işlenmişse buna ilişkin bizden bilgi talep etme</li>
              <li>Kişisel verilerinizin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme</li>
              <li>Yurt içinde veya yurt dışında kişisel verilerinizin aktarıldığı üçüncü kişileri bilme</li>
              <li>Kişisel verilerinizin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini isteme</li>
              <li>İşlenmesini gerektiren sebeplerin ortadan kalkması hâlinde kişisel verilerinizin silinmesini veya yok edilmesini isteme</li>
              <li>İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle kendi aleyhine bir sonucun ortaya çıkmasına itiraz etme</li>
              <li>Kişisel verilerin kanuna aykırı olarak işlenmesi sebebiyle zarara uğramanız hâlinde zararın giderilmesini talep etme</li>
            </ul>
          </div>

          <div className="policy-section">
            <h2>9. Politikanın Yürürlüğü</h2>
            <p>
              Bu Politika yayınlandığı tarihte yürürlüğe girer. Politika'nın tümünün veya belirli maddelerinin yenilenmesi halinde Politika'nın yürürlük tarihi revize edilir.
            </p>
            <p className="last-updated">
              <strong>Son güncelleme:</strong> {new Date().toLocaleDateString('tr-TR')}
            </p>
          </div>

          <div className="policy-section">
            <h2>10. İletişim</h2>
            <p>
              Haklarınıza ilişkin taleplerinizi, Veri Sorumlusuna Başvuru Usul ve Esasları Hakkında Tebliğ'e uygun şekilde yazılı olarak ya da elektronik posta adresinizi kullanarak aşağıda belirtmiş olduğumuz adreslere her zaman iletebilirsiniz.
            </p>
            <div className="contact-info">
              <p><strong>Veri Sorumlusu:</strong> ProgenX Eğitim ve Bilişim Teknolojileri A.Ş.</p>
              <p><strong>E-posta:</strong> info@progenxacademy.com<br /></p>
              <p><strong>Web Sitesi:</strong> www.progenxacademy.com</p>
              <p><strong>Adres:</strong> Ankara, Türkiye<br /></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;
